import React, { useEffect, useRef, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { handleGetRequest } from '../../service/GetTemplate';
import { handlePostRequest } from '../../service/PostTemplate';
import { handlePutRequest } from '../../service/PutTemplate';
import { endPoints } from '../../Config';
import { useDispatch } from 'react-redux';
import { Dropdown } from 'primereact/dropdown';
import SecuredFileChange from '../../components/SecuredFileChange';

const AddEditOutlets = ({ editable, viewable, onHide, rowRecord, onCancel }) => {
    const [loadingBtn, setLoadingBtn] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);

    const customerImageRef = useRef(null);

    const dispatch = useDispatch();

    const validationSchema = Yup.object().shape({
        // name: Yup.string()
        //  .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
        // .required('This field is required')
        //   .matches(/^[a-zA-Z0-9\s]*$/, 'Name must contain only alphanumeric values'),
        // location: Yup.string()
        // .matches(/^\d+$/, 'location ')
        // .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
        //   .required('This field is required'),
        // consumerId: Yup.string()
        // .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
        //   .required('This field is required'),
        // dateOfBirth: Yup.string().required('This field is required'),
        // cnic: Yup.string()
        //  .matches(/^\d+$/, 'Cnic should only contain numbers')
        // .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
        //   .required('This field is required'),
        // gender: Yup.string().required('This field is required'),
        // emailAddress: Yup.string()
        // .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
        // .email('Invalid email')
        //  .required('This field is required'),
        // address: Yup.string()
        // .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
        //   .required('This field is required'),
        // profileImageBase64: Yup.string().required('This field is required')
    });

    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            name: '',
            location: '',
            contactName: '',
            mobileNumber: '',
            accountNumber: '',
            accountTitle: '',
            bank: '',
            status: 'IN ACTIVE'
        },
        onSubmit: async (data) => {
            const user = JSON.parse(localStorage.getItem('user') || '{}');

            const formData = new FormData();
            if (!editable) {
                setLoadingBtn(true);

                formData.append('name', data?.name || '');
                formData.append('location', data?.location || '');
                formData.append('contactName', data?.contactName || '');
                formData.append('mobileNumber', data?.mobileNumber || '');
                formData.append('accountNumber', data?.accountNumber || '');
                formData.append('accountTitle', data?.accountTitle || '');
                formData.append('bank', data?.bank || '');

                if (selectedFile) formData.append('profileImage', selectedFile);

                const response = await dispatch(handlePostRequest(formData, endPoints.addCustomer, true));
                if (response?.status === 200) {
                    formik.resetForm();
                    onHide();
                }
                setLoadingBtn(false);
            } else {
                setLoadingBtn(true);

                formData.append('name', data?.name || '');
                formData.append('location', data?.location || '');
                formData.append('contactName', data?.contactName || '');
                formData.append('mobileNumber', data?.mobileNumber || '');
                formData.append('accountNumber', data?.accountNumber || '');
                formData.append('accountTitle', data?.accountTitle || '');
                formData.append('bank', data?.bank || '');

                if (selectedFile) formData.append('profileImage', selectedFile);

                const response = await dispatch(handlePutRequest(formData, endPoints.updateCustomer, true));
                if (response?.status === 200) {
                    formik.resetForm();
                    onHide();
                }
                setLoadingBtn(false);
            }
        }
    });

    const getCustomerbyId = async () => {
        setLoadingBtn(true);
        const response = await handleGetRequest(endPoints.getCustomerById(rowRecord.id), true);
        if (response) {
            formik.setFieldValue('name', response?.data?.name);
            formik.setFieldValue('location', response?.data?.location);
            formik.setFieldValue('contactName', response?.data?.contactName);
            formik.setFieldValue('mobileNumber', response?.data?.mobileNumber);
            formik.setFieldValue('accountNumber', response?.data?.accountNumber);
            formik.setFieldValue('accountTitle', response?.data?.accountTitle);
            formik.setFieldValue('bank', response?.data?.bank);
        }
        setLoadingBtn(false);
    };

    useEffect(() => {
        if (editable || viewable) {
            getCustomerbyId();
        }
    }, [rowRecord]);

    const handleCustomerIcon = () => {
        customerImageRef.current.click();
    };

    function handleCustomerImageChange(event) {
        setSelectedFile(null);
        formik.setFieldValue('profileImageBase64', '');
        const selectedFile = event.target.files[0];
        const fileTypes = ['image'];
        const { file: newFile, error } = SecuredFileChange(selectedFile, fileTypes);
        if (error) {
        } else if (newFile) {
            formik.setFieldValue('profileImageBase64', newFile?.name);
            setSelectedFile(newFile);
        }
    }
    function formatedDate(originalDate) {
        const createDate = new Date(originalDate);

        const year = createDate.getFullYear();
        const month = (createDate.getMonth() + 1).toString().padStart(2, '0'); // Month is zero-based
        const day = createDate.getDate().toString().padStart(2, '0');

        return `${year}-${month}-${day}`;
    }

    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate());
    const previousDate = currentDate.toISOString().split('T')[0];

    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="grid p-fluid">
                <div className="col-12 md:col-6">
                    <div className="field mb-3">
                        <label htmlFor="name">
                            Name <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText id="name" name="name" placeholder="Enter Customer Name" value={formik?.values?.name} maxLength={30} onChange={formik.handleChange} disabled={viewable} />
                        {formik.touched.name && formik.errors.name && <small className="p-error">{formik.errors.name}</small>}
                    </div>
                </div>
                <div className="col-12 md:col-6">
                    <div className="field mb-3">
                        <label htmlFor="location">
                            location <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText id="location" name="location" placeholder="Enter Location" value={formik?.values?.location} maxLength={11} onChange={formik.handleChange} disabled={viewable} />
                        {formik.touched.location && formik.errors.location && <small className="p-error">{formik.errors.location}</small>}
                    </div>
                </div>
                <div className="col-12 md:col-6">
                    <div className="field mb-3">
                        <label htmlFor="contactName">
                            Contact Name <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText id="contactName" name="contactName" placeholder="Enter Contact Name" value={formik?.values?.contactName} maxLength={30} onChange={formik.handleChange} disabled={viewable} />
                        {formik.touched.contactName && formik.errors.contactName && <small className="p-error">{formik.errors.contactName}</small>}
                    </div>
                </div>
                <div className="col-12 md:col-6">
                    <div className="field mb-3">
                        <label htmlFor="mobileNumber">
                            Mobile Number <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText id="mobileNumber" name="mobileNumber" placeholder="Enter Mobile Number" value={formik?.values?.mobileNumber} maxLength={13} onChange={formik.handleChange} disabled={viewable} />
                        {formik.touched.mobileNumber && formik.errors.mobileNumber && <small className="p-error">{formik.errors.mobileNumber}</small>}
                    </div>
                </div>
                <div className="col-12 md:col-6">
                    <div className="field mb-3">
                        <label htmlFor="accountNumber">
                            Account Number <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText id="accountNumber" name="accountNumber" placeholder="Enter Account Number" value={formik?.values?.accountNumber} maxLength={30} onChange={formik.handleChange} disabled={viewable} />
                        {formik.touched.accountNumber && formik.errors.accountNumber && <small className="p-error">{formik.errors.accountNumber}</small>}
                    </div>
                </div>
                <div className="col-12 md:col-6">
                    <div className="field mb-3">
                        <label htmlFor="accountTitle">
                            Account Title <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText id="accountTitle" name="accountTitle" placeholder="Enter Account Title" value={formik?.values?.accountTitle} maxLength={100} onChange={formik.handleChange} disabled={viewable} />
                        {formik.touched.accountTitle && formik.errors.accountTitle && <small className="p-error">{formik.errors.accountTitle}</small>}
                    </div>
                </div>
                <div className="col-12 md:col-6">
                    <div className="field mb-3">
                        <label htmlFor="bank">
                            Bank <span style={{ color: 'red' }}>*</span>
                        </label>
                        <Dropdown id="bank" name="bank" placeholder="Select Bank" value={formik?.values?.bank} maxLength={100} onChange={formik.handleChange} disabled={viewable} />
                        {formik.touched.bank && formik.errors.bank && <small className="p-error">{formik.errors.bank}</small>}
                    </div>
                </div>{' '}
            </div>

            <div className="flex justify-content-center mt-4 gap-2">
                {!viewable && (
                    <Button label={editable ? 'Update' : 'Save'} icon={editable ? 'pi pi-pencil' : 'pi pi-save'} type="submit" disabled={loadingBtn} className="p-button-success p-button-sm" style={{ minWidth: 90, maxWidth: 120, width: 'auto' }} />
                )}
                <Button label="Cancel" icon="pi pi-times" type="button" className="p-button-secondary p-button-sm" style={{ minWidth: 90, maxWidth: 120, width: 'auto' }} onClick={() => onCancel()} />
            </div>
        </form>
    );
};

export default AddEditOutlets;
